import { t } from "i18next";
import { createContext, useRef, useState } from "react";
import { AkciznaMarkicaKategorijaProzivoda } from "../modules/obligee/exciseStamps/exciseStamps.types";

interface ModalsContextState {
  modalVisible: string;
  isLoading: boolean;
  infoTitle: string;
  infoMessage: string;
  vozilo: string;
  pretovar: string;
  napomena: string;
  type: string;
  ttId: number | null;
  statusZahteva: number | null;
  tipPakovanjaId: number | null;
  section: string;
  data: any[];
  id: number | null;
  iskoriscenOpsegId: number | null;
  dozvolaZahtevId: number | null;
  markicaZahtevId: number | null;
  zahtevId: number | null;
  record: any;
  kategorijaProizvoda: string;
  onReload: boolean;
  markicaKategorijeId: AkciznaMarkicaKategorijaProzivoda | null;
  isPosebniPostupak: boolean | null;
}

export type UpdateModalStateFunction = (
  updatedState: Partial<ModalsContextState>
) => void;

export interface ModalContextProviderProps {
  children: JSX.Element;
}

const initialState = (): ModalsContextState => ({
  modalVisible: "",
  infoTitle: "",
  infoMessage: "",
  pretovar: "",
  napomena: "",
  vozilo: "",
  tipPakovanjaId: null,
  isLoading: false,
  type: "",
  section: "",
  data: [],
  statusZahteva: null,
  isPosebniPostupak: false,
  dozvolaZahtevId: null,
  zahtevId: null,
  ttId: null,
  markicaZahtevId: null,
  kategorijaProizvoda: "",
  id: null,
  iskoriscenOpsegId: null,
  record: {
    ime: "",
    prezime: "",
    brojLicneKarte: "",
    datumVazenjaOvlascenjaOd: "",
    datumVazenjaOvlascenjaDo: "",
    aktivno: true,
  },
  onReload: false,
  markicaKategorijeId: null,
});

export const ModalsContext = createContext<{
  modals: ModalsContextState;
  handleUpdateModals: UpdateModalStateFunction;
  isModalVisible: any;
  clearModals: any;
  loaderRef: any;
  startLoader: any;
  endLoader: any;
  setError: any;
}>(null as any);

export const ModalsContextProvider = ({
  children,
}: ModalContextProviderProps) => {
  const [modals, setModals] = useState(initialState());
  const loaderRef = useRef(null);

  const isModalVisible = (modalName: string) =>
    modals.modalVisible === modalName;

  const handleUpdateModals = (updatedState: Partial<ModalsContextState>) => {
    setModals((prevState) => ({ ...prevState, ...updatedState }));
  };

  const clearModals = () => {
    setModals(initialState());
  };

  const startLoader = () => {
    if (loaderRef.current) {
      handleUpdateModals({ isLoading: true });
      //@ts-ignore
      loaderRef.current.continuousStart();
    }
  };

  const endLoader = () => {
    if (loaderRef.current) {
      handleUpdateModals({ isLoading: false });
      //@ts-ignore
      loaderRef.current.complete();
    }
  };

  const parseApiError = (error: string) => {
    return (
      // error?.response?.data?.error_description ||
      // error?.response?.data?.Message ||
      // error?.response?.data ||
      // || "Nešto je pošlo po zlu"
      error || t("COMMON.DOSLO_JE_DO_GRESKE_KONTAKTIRAJTE")
    );
  };

  const setError = (error: string) => {
    handleUpdateModals({
      infoMessage: parseApiError(error),
      infoTitle: "Greška:",
      modalVisible: "info",
    });
  };

  return (
    <ModalsContext.Provider
      value={{
        startLoader,
        endLoader,
        modals,
        handleUpdateModals,
        isModalVisible,
        clearModals,
        loaderRef,
        setError,
      }}
    >
      {children}
    </ModalsContext.Provider>
  );
};
